import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FilterOptions } from '@app-model/filter';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import {BusinessPartnerData, BusinessPartnerPageableResponse} from "@app-model/businessPartner.model";

@Injectable({
	providedIn: 'root'
})

export class BusinessPartnerService {
  constructor(private http: HttpClient) {}

  paginate(filter: FilterOptions): Observable<BusinessPartnerPageableResponse> {
		return this.http.post(`${environment.api}/adminBusinessPartner/list`, filter).pipe(map(
    (response: BusinessPartnerPageableResponse) => response));
	}

  getBusinessPartner(id: number) {
    return this.http.get(`${environment.api}/adminBusinessPartner/${id}`).pipe(
			map((response: BusinessPartnerData) => response),take(1)
		);
	}

  saveBusinessPartner(businessPartner: BusinessPartnerData): Observable<BusinessPartnerPageableResponse> {
		return this.http.post(`${environment.api}/adminBusinessPartner/save`, businessPartner)
    .pipe(map((response: BusinessPartnerPageableResponse) => response));
	}

  removeBusinessPartner(businessPartner: BusinessPartnerData): Observable<BusinessPartnerPageableResponse> {
		return this.http.delete(`${environment.api}/adminBusinessPartner/${businessPartner.id}`)
    .pipe(map((response: BusinessPartnerPageableResponse) => response));
	}
}
